<template>
    <div id="main" class="app-main">
        <router-view></router-view>
        <Modal v-model="loginModal" title="Please input a password" :width="540" @on-ok="passwordOk"
            @on-cancel="passwordCancel" okText='OK' cancelText='Cancel'>
            <Row>
            <Col span="5" style="padding-right:4px;">
                <span style="color: red;">*</span><span style="line-height:32px;" class="label-text">Password ：</span>
            </Col>
            <Col span="15" >
                <form>
                <div style="display:none;"><Input type="text" placeholder="Please input a password"></Input></div>
                <el-input placeholder="Please input a password" v-model="Password_base" show-password></el-input>
                </form>
            </Col>
            </Row>
        </Modal>
    </div>
</template>

<script>
import util from '@/utils/util.js';
    export default {
        data () {
            return {
                theme: this.$store.state.app.themeColor,
                loginModal : false,
                Password_base: '',
                isLogin: false
            };
        },
        mounted () {

        },
        beforeDestroy () {

        },
        created () {
            util.mapRouters(this);
        },
        methods: {
            passwordOk() {
                if (this.Password_base == 'a123456') {
                    this.isLogin = true
                } else {
                    this.$Notice.error({
                        title: "Password error"
                    });
                    this.$router.push({path:'/home/index'});
                }
            },
            passwordCancel (){
                this.$router.push({path:'/home/index'});
            }
        },
        watch: {

        }
    };
</script>

<style lang="less">
html,body{
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    overflow: hidden;
}
.app-main{
    width: 100%;
    height: 100%;
}
.ivu-select-multiple .ivu-select-selection {
  min-height: 36px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
.padding-top-16 {
  padding-top: 16px;
}
.margin-forty{
  margin: 40px 0;
}
.model-info {
  font-size: 16px;
}
.ivu-modal .el-form-item {
 margin-bottom: 10px;
}
.ivu-notice-title {
  text-overflow: clip !important;
  overflow: visible !important;
  white-space: normal !important;
}
  /* 全局滚动条美化 */
 /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar{
    width: 7px;
    height: 7px;
    background-color: #F5F5F5;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
    background-color: #c8c8c8;
  }
.ivu-input {
  font-size: 14px;
}

/* 大图查看 */
.image-viewer-container {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  justify-content: center;
  align-items: center;

  img {
    max-width: 90%;
    max-height: 90%;
  }

  &.show {
    display: flex;
  }

  .arrow-btn {
    display: none;
    position: absolute;
    top: 50%;
    left: 0;
    justify-content: space-between;
    width: 100%;
    margin-top: -35px;
    z-index: 10;

    .arrow-btn-left,
    .arrow-btn-right {
      width: 70px;
      height: 70px;
      text-align: center;
      color: #fff;
      font-size: 36px;
      font-weight: bold;
      line-height: 70px;
      background-color: rgba(0, 0, 0, 0.5);
      cursor: pointer;
      border-radius: 70px;
    }

    .arrow-btn-left {
      margin-left: 10px;
    }

    .arrow-btn-right {
      margin-right: 10px;
    }

    &.show {
      display: flex;
    }
  }
}
.nopadding {
  padding: 0 !important;
}
.g-watermarker-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: 320px 250px;
  pointer-events: none;
  z-index: 100000000;
}
.g-watermarker-mask-warnning {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  box-shadow: inset 0 0 150px rgba(255, 0, 0, 0.8);
  pointer-events: none;
  z-index: 100000001;
}
.el-message__content {
  word-break: break-all;
}
.input-error .el-input__inner, .input-error .el-input__inner:focus, .input-error .el-textarea__inner, .input-error .el-textarea__inner:focus {
  border-color: #f56c6c;
}
</style>
